export default __webpack_public_path__ + "static/media/transform-lifes-4-costa-rica.8a5bad65.png";